<template>
  <div class="contact-page">
    <div class="contact-container">
      <h1 class="contact-title">联系我们</h1>

      <div class="contact-icons">
        <div class="contact-item">
          <img :src="qrcode1" alt="TG" class="qr-code" />
          <span>TG咨询(白班8:00-19:00)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode2" alt="whatsApp" class="qr-code" />
          <span>whatsApp咨询(白班8:00-19:00)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode3" alt="line" class="qr-code" />
          <span>Line咨询(白班8:00-19:00)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode4" alt="TG" class="qr-code" />
          <span>TG咨询(夜班19:00-5:00)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode5" alt="whatsApp" class="qr-code" />
          <span>whatsApp咨询(夜班19:00-5:00)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode6" alt="line" class="qr-code" />
          <span>Line咨询(夜班19:00-5:00)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode7" alt="line" class="qr-code" />
          <span>tg咨询(售后客服)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode8" alt="line" class="qr-code" />
          <span>whatsApp咨询(售后客服)</span>
        </div>
        <div class="contact-item">
          <img :src="qrcode9" alt="line" class="qr-code" />
          <span>Line咨询(售后客服)</span>
        </div>
      </div>

      <div class="back-button">
        <a-button type="primary" @click="goBack">返回</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'ContactPage',
  setup() {
    const router = useRouter()
    const qrcode1 = ref(null)
    const qrcode2 = ref(null)
    const qrcode3 = ref(null)
    const qrcode4 = ref(null)
    const qrcode5 = ref(null)
    const qrcode6 = ref(null)
    const qrcode7 = ref(null)
    const qrcode8 = ref(null)
    const qrcode9 = ref(null)

    onMounted(() => {
      // 在组件挂载后加载图片
      qrcode1.value = require('@/assets/qrcode1.jpg')
      qrcode2.value = require('@/assets/qrcode2.jpg')
      qrcode3.value = require('@/assets/qrcode3.jpg')
      qrcode4.value = require('@/assets/qrcode4.jpg')
      qrcode5.value = require('@/assets/qrcode5.jpg')
      qrcode6.value = require('@/assets/qrcode6.jpg')
      qrcode7.value = require('@/assets/qrcode7.jpg')
      qrcode8.value = require('@/assets/qrcode8.jpg')
      qrcode9.value = require('@/assets/qrcode9.jpg')
    })

    const goBack = () => {
      router.back()
    }

    return {
      qrcode1,
      qrcode2,
      qrcode3,
      qrcode4,
      qrcode5,
      qrcode6,
      qrcode7,
      qrcode8,
      qrcode9,
      goBack
    }
  }
})
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  overflow-y: auto;
}

.contact-container {
  max-width: 1200px;
  width: 100%;
  text-align: center;
  background: rgba(255, 255, 255, 0.05);
  padding: 40px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  margin: 40px auto;
}

.contact-title {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 60px;
  font-weight: 300;
  letter-spacing: 2px;
}

.contact-icons {
  display: flex;
  justify-content: center;
  gap: 80px;
  flex-wrap: wrap;
  margin-bottom: 60px;
}

.contact-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.contact-item:hover {
  transform: translateY(-5px);
}

.qr-code {
  width: 200px;
  height: 200px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: #fff;
}

.qr-code:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

.contact-item span {
  font-size: 1.2rem;
  color: #fff;
  opacity: 0.9;
}

.back-button {
  margin-top: 40px;
}

.back-button :deep(.ant-btn) {
  height: 44px;
  padding: 0 32px;
  font-size: 16px;
  border-radius: 22px;
  background: #1890ff;
  border: none;
}

.back-button :deep(.ant-btn:hover) {
  background: #40a9ff;
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-page {
    padding: 20px 10px;
  }

  .contact-container {
    padding: 20px;
    margin: 20px auto;
  }

  .contact-icons {
    gap: 40px;
  }

  .qr-code {
    width: 160px;
    height: 160px;
  }

  .contact-title {
    font-size: 2rem;
    margin-bottom: 40px;
  }

  .contact-item span {
    font-size: 1rem;
  }
}
</style> 